<template>
	<div
		class="flex flex-col items-start"
		:class="layout === 'labels-only' && 'flex-row flex-wrap items-center gap-x-2 gap-y-0.5'"
	>
		<template v-if="layout === 'price-only'">
			<PriceBoxDefault
				:price="mainPrice"
				:small-price="smallPrice"
				:only-large-price="onlyLargePrice"
			/>
		</template>

		<template v-else-if="layout === 'labels-only'">
			<template v-if="isGlobusBonusPrice(productInHouse) && isBonusProgramPriceValidDate(productInHouse)">
				<template v-if="isBargain(productInHouse)">
					<PriceBoxBargain
						:price="getCurrentPrice(productInHouse)"
						badge-only
						:small-price="smallPrice"
					/>
				</template>
				<template v-else-if="isDiscountPercentage(productInHouse)">
					<PriceBoxOriginal :price="getNormalPrice(productInHouse)" :only-large-price="onlyLargePrice" />
					<PriceBoxBargain
						:price="getCurrentPrice(productInHouse)"
						:sale="productInHouse.discountPercentage"
						badge-only
						:small-price="smallPrice"
					/>
				</template>
			</template>
			<PriceBoxBargain
				v-else-if="isBargain(productInHouse)"
				:price="getCurrentPrice(productInHouse)"
				badge-only
				:small-price="smallPrice"
			/>
			<template v-else-if="isDiscountPercentage(productInHouse)">
				<PriceBoxOriginal :price="getNormalPrice(productInHouse)" :only-large-price="onlyLargePrice" />
				<PriceBoxBargain
					:price="getCurrentPrice(productInHouse)"
					:sale="productInHouse.discountPercentage"
					badge-only
					:small-price="smallPrice"
				/>
			</template>
		</template>

		<template v-else>
			<template v-if="isGlobusBonusPrice(productInHouse) && isBonusProgramPriceValidDate(productInHouse)">
				<template v-if="isBargain(productInHouse)">
					<PriceBoxBargain :price="getCurrentPrice(productInHouse)" :small-price="smallPrice" :only-large-price="onlyLargePrice" />
					<PriceBoxSale
						v-if="!hideClubPrice"
						:price="productInHouse.bonusProgramPrice?.actualPrice ?? 0"
						:sale="productInHouse.bonusProgramPrice?.discount"
					/>
				</template>
				<template v-else-if="isDiscountPercentage(productInHouse)">
					<PriceBoxOriginal :price="getNormalPrice(productInHouse)" :only-large-price="onlyLargePrice" />
					<PriceBoxBargain :price="getCurrentPrice(productInHouse)" :sale="productInHouse.discountPercentage" :small-price="smallPrice" :only-large-price="onlyLargePrice" />
					<PriceBoxSale
						v-if="!hideClubPrice"
						:price="productInHouse.bonusProgramPrice?.actualPrice ?? 0"
						:sale="productInHouse.bonusProgramPrice?.discount"
					/>
				</template>
				<template v-else>
					<PriceBoxDefault :price="getNormalPriceWithCurrentPriceFallback(productInHouse)" :small-price="smallPrice" :only-large-price="onlyLargePrice" />
					<PriceBoxSale
						v-if="!hideClubPrice"
						:price="productInHouse.bonusProgramPrice?.actualPrice ?? 0"
						:sale="productInHouse.bonusProgramPrice?.discount"
					/>
				</template>
			</template>
			<PriceBoxBargain v-else-if="isBargain(productInHouse)" :price="getCurrentPrice(productInHouse)" :small-price="smallPrice" :only-large-price="onlyLargePrice" />
			<template v-else-if="isDiscountPercentage(productInHouse)">
				<PriceBoxOriginal :price="getNormalPrice(productInHouse)" :only-large-price="onlyLargePrice" />
				<PriceBoxBargain
					:price="getCurrentPrice(productInHouse)"
					:sale="productInHouse.discountPercentage"
					:small-price="smallPrice"
					:only-large-price="onlyLargePrice"
				/>
			</template>
			<PriceBoxDefault v-else :price="getCurrentPrice(productInHouse)" :small-price="smallPrice" :only-large-price="onlyLargePrice" />
		</template>
	</div>
</template>

<script setup lang="ts">
	import type {Gsoa_ShoppingList_GetItemsCollection as ShoppingListItem, Gsoa_ProductCatalog_ProductInHouse as ProductInHouse} from '~/openapi';

	type Layout = 'full' | 'price-only' | 'labels-only';

	interface Props {
		productInHouse: ProductInHouse
		smallPrice?: boolean
		onlyLargePrice?: boolean
		layout?: Layout
		hideClubPrice?: boolean
		amount?: ShoppingListItem['Amount']
	}

	const props = withDefaults(defineProps<Props>(), {
		layout: 'full',
		hideClubPrice: false,
	});

	function getNormalPriceWithCurrentPriceFallback(productInHouse: ProductInHouse) {
		const normalPrice = getNormalPrice(productInHouse);
		return normalPrice || getCurrentPrice(productInHouse);
	}

	const mainPrice = computed(() => (
		getMainTriplePrice(props.productInHouse) * (props.amount || 1)
	));
</script>
